// import { tns } from 'tiny-slider/src/tiny-slider'

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';


function initCarousels() {
	return new Swiper(".programme-carousel", {
		modules: [Navigation, Pagination],
		slidesPerView: 1.35,
		centeredSlides: false,
		loop: true,
		spaceBetween: 30,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		breakpoints: {
			640: {
			  slidesPerView: 2.25,
			  spaceBetween: 20,
			},
			768: {
			  slidesPerView: 2.75,
			  spaceBetween: 40,
				pagination: {
					el: ".swiper-pagination",
					type: "progressbar",
					clickable: true,
				},
			},
			
		  },
	})
}

function initTabModule(el) {
	const tabs = [...el.querySelectorAll('.js-programme-carousel-tabs__tab')]
	let activeTab = el.querySelector('.js-programme-carousel-tabs__tab.active')
	
	const content = [...el.querySelectorAll('.js-programme-carousel-tabs__content')]
	let activeContent = el.querySelector('.js-programme-carousel-tabs__content.active')

	content.map(item => {
		if (item === activeContent) return
		item.style.display = 'none'
	})

	tabs.map(tab => {
		tab.addEventListener('click', event => {
			event.preventDefault()
			const tab = event.currentTarget
			const tabId = parseInt(tab.getAttribute('data-tab-id') || '')
			for (const item of content) {
				const contentId = parseInt(item.getAttribute('data-tab-id') || '')
				if (contentId === tabId) {
					activeTab.classList.remove('active')
					activeTab.setAttribute('aria-selected', 'false')

	                tab.classList.add('active')
					tab.setAttribute('aria-selected', 'true')
					activeTab = tab

					activeContent.style.display = 'none'
					activeContent.classList.remove('active')
					item.classList.add('active')
					item.style.display = ''
					activeContent = item
				}
			}
		})
	})
}

export default () => {
	initCarousels()
	;[...document.querySelectorAll('.js-programme-carousel-tabs')].map(initTabModule)
}